import React from 'react';
import {NavLink} from 'react-router-dom';
import { useLocale } from '../../localization/LocaleContext';
import './sidedrawer.css';


const SideDrawer = props => {
    const { t, toLocalizedPath } = useLocale();
    let drawerClasses = ['side-drawer']
    if(props.show){
        drawerClasses = ['side-drawer open']
    }
    // console.log(props)

    return(
        <nav className={drawerClasses} onClick={props.drawerClickHandler}>
            <ul>
                <li>
                    <img src={`${process.env.PUBLIC_URL}/images/main-logo.svg`} alt="Invoice Point logo" />
                </li>
                <li>
                    <NavLink exact={true} activeStyle={{color:"#27c492"}} to={toLocalizedPath('home')}>
                        {t('nav.home')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('freelancers')}>
                        {t('nav.freelancers')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('smallBusiness')}>
                        {t('nav.smallBusiness')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('organization')}>
                        {t('nav.organization')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('faqs')}>
                        {t('nav.faqs')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('pricing')}>
                        {t('nav.pricing')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('termsOfService')}>
                        {t('nav.terms')}
                    </NavLink>
                </li>
                <li>
                    <NavLink activeStyle={{color:"#27c492"}} to={toLocalizedPath('privacyPolicy')}>
                        {t('nav.privacy')}
                    </NavLink>
                </li>
            </ul>
        </nav>
    )
}

export default SideDrawer;